const calendarEventDbFields = 'allDay, extendedProps, id, location, title, _user_id, rrule, duration, collaborators, status, _metaData';

// const eventDirectoryDbFields = `allDay, extendedProps, id, location, title, _user_id, rrule, duration, collaborators, status`;
const eventDirectoryDbFields = `allDay, extendedProps, id, location (name, id), title, _user_id, rrule, duration, collaborators, status`;

export { calendarEventDbFields, eventDirectoryDbFields };
